import type { ParentProps } from 'solid-js';
import { HydrationScript } from '@solidjs/web';

// The document shell (replaces index.html). Renders the full <html>; the
// plugin injects the client entry script and built CSS into <head>.
// html.js is set before first paint so .reveal elements start hidden only
// when the script that reveals them will run.
const BOOT = `document.documentElement.classList.add('js');`;

export default function Document(props: ParentProps) {
  return (
    <html lang="fr-CA">
      <head>
        <meta charset="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content="#0A1628" />
        <link rel="icon" href="/favicon-32.png" sizes="32x32" type="image/png" />
        <link rel="icon" href="/favicon-192.png" sizes="192x192" type="image/png" />
        <link rel="apple-touch-icon" href="/favicon-180.png" />
        <link rel="manifest" href="/site.webmanifest" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin="anonymous" />
        <link
          href="https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,400..800&display=swap"
          rel="stylesheet"
        />
        <script innerHTML={BOOT} />
        <HydrationScript />
      </head>
      <body>{props.children}</body>
    </html>
  );
}
